export default "__VITE_ASSET__21deae91__"